module.exports = __webpack_public_path__ + "img/13.ff5b0d6f.png";